<!--  -->
<template>
  <div class="classification">
    <div class="header">
      <span class="font">商品分类</span>
    </div>

    <div class="center"
         style="position:relative">
      <div class="shangjia">
        <el-button size="small"
                   type="primary"
                   @click="editHandle()">添加商品分类</el-button>
      </div>
      <el-table :data="tableData"
                :key="number"
                style="width: 100%;"
                row-key="id"
                lazy
                :load="load"
                :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
        <el-table-column type=""
                         prop="id"
                         label="分类ID"
                         width="180">
        </el-table-column>
        <el-table-column prop="name"
                         label="分类名称"
                         width="180">
        </el-table-column>
        <el-table-column prop="shopNumber"
                         label="商品数">
        </el-table-column>
        <el-table-column prop="enable"
                         label="是否启用">
        </el-table-column>
        <el-table-column prop="navigationRecommed"
                         label="导航推荐">
        </el-table-column>
        <el-table-column prop="sort"
                         label="排序">
        </el-table-column>
        <el-table-column prop="caozuo"
                         label="操作">
          <template slot-scope="scope">
            <!-- <el-button type="button" size="mini" icon="el-icon-upload2" @click="deleteHandle(scope.row)">上架</el-button> -->

            <el-link :underline="false"
                     type="primary"
                     @click="editHandle(scope.row)">编辑</el-link>
            <el-link :underline="false"
                     style="margin-left:16px"
                     type="primary"
                     @click="deleteHandle(scope.row)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog title="删除商品分类"
               :visible.sync="dialogVisibleDelete"
               width="30%"
               :before-close="handleCloseDelete">
      <span>请确认是否要删除商品分类</span>
      <span slot="footer"
            class="dialog-footer">
        <el-button size="small"
                   @click="dialogVisibleDelete = false">取消</el-button>
        <el-button size="small"
                   type="primary"
                   @click="deleteShop">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import MyTable from '@/components/myTable'
import { queryGoodsClassList, deleteOne } from '@/api/productManage/goodsManger'
// import avater from "/public/img/default.png"

export default {
  name: 'WareProduct',
  components: { MyTable },
  data () {
    return {
      number: 1,
      row: '',
      dialogVisibleDelete: false,
      showpage: false,
      dialogVisible: false,
      tableData: [],
    }
  },
  computed: {},
  watch: {},
  created () {
    this.queryGoodsClassList()
  },
  mounted () {

  },
  beforeCreate () { },
  beforeMount () { },
  beforeUpdate () { },
  updated () { },
  beforeDestroy () { },
  destroyed () { },
  activated () { },
  methods: {
    handleCloseDelete () {
      this.dialogVisibleDelete = false
    },
    editHandle (row) {
      if (row) {
        this.$router.push({
          path: '/productManage/goodsManage-classification-edit',
          query: {
            name: '编辑',
            id: row.id,
            level: row.level
          }
        }
        )
      } else {
        this.$router.push({
          path: '/productManage/goodsManage-classification-edit'
        }
        )
      }
    },
    // 确定删除
    deleteShop () {
      deleteOne({ id: this.row.id }).then(res => {
        if (res.code == 0) {
          this.$message.success('删除成功')
        } else {
          this.$message.success('删除失败')
        }
        this.dialogVisibleDelete = false
        this.queryGoodsClassList()
      })
    },
    deleteHandle (row) {
      this.row = row
      if (row.shopNumber > 0) {
        this.$message({
          type: 'error',
          showClose: true,
          dangerouslyUseHTMLString: true,
          message: '<div><span style="font-size:16px">无法删除分类</span><div>该分类下还有商品，请清除分类下的商品，再删除分类</div></div>',

        })
      } else {
        this.dialogVisibleDelete = true
      }
      // const params = [{
      //   goodsId: row.goodsId
      // }]
      // putaway(params).then(res => {
      //   if (res.code === 0) {
      //     this.$message.success('上架成功')
      //     this.reset()
      //     // this.queryGoodsClassList(1)
      //   } else {
      //     this.$message.error('上架失败')
      //   }
      // })
    },
    // 查询
    queryGoodsClassList () {
      queryGoodsClassList().then(res => {
        if (res.code == 0 && res.data) {
          this.tableData = res.data
          this.tableData.forEach(item => {
            this.$set(item, 'hasChildren', true)
          })
          this.number = this.number + 1
        } else {
          this.tableData = []
        }
      })
    },
    load (tree, treeNode, resolve) {
      let params = {
        currentId: tree.id,
        levelParam: String(Number(tree.level) + 1)
      }
      queryGoodsClassList(params).then(res => {
        if (res.code == 0 && res.data) {
          let resData = []
          resData = res.data
          resData.forEach(item => {
            if (item.level < 3) {
              this.$set(item, 'hasChildren', true)
            }
          })
          setTimeout(() => {
            resolve(resData)
          }, 500)
        } else {
          resolve([])
        }
      })

    },
  }
}
</script>
<style lang='scss' scoped>
.classification {
  padding: 0px;
}
.header {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 24px 0px 24px !important;
  border-bottom: 1px solid #f5f5f5;
  .font {
    font-size: 16px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 600;
    text-align: left;
    color: #262626;
  }
  .el-form-item {
    margin: 0px 0px 0px 8px !important;
  }
}
.center {
  margin-top: 16px;
  padding: 0 24px 0 24px;
  height: calc(100% - 120px);
  ::v-deep .imageP {
    width: calc(100% - 110px);
    p {
      margin: 0 0 0 10px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .shangjia {
    // position: absolute;
    // z-index: 2;
    // bottom: -45px;
  }
  ::v-deep .el-dialog__body {
    padding-bottom: 0px;
  }
}
</style>
